// extracted by mini-css-extract-plugin
module.exports = {"facebook_button":"FacebookLogin_facebook_button__fRsu8","facebook_logo":"FacebookLogin_facebook_logo__EFHpW"};